import React, { useState } from "react";
import { createHash } from "utils/helperFunctions";
import { firefuncs } from "config/firebase";
import { httpsCallable } from "firebase/functions";

import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";

interface PrivateGameSearchProps {
  userId?: string;
  displayName?: string;
}

function PrivateGameSearch(props: PrivateGameSearchProps) {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    accesscode: "",
    msg: "",
  });

  const handleInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    setValues({ ...values, [name]: value });
  };

  const findPrivCashGame = async (evt: React.FormEvent) => {
    evt.preventDefault();
    setLoading(true);
    const codeHash = createHash(values.accesscode);

    const data = {
      userId: props.userId,
      displayName: props.displayName,
      gameId: codeHash,
    };
    if (values.accesscode === "") {
      setLoading(false);
      setValues({ msg: "Access Code required", accesscode: "" });
    } else {
      const addUserToPrivGame = httpsCallable(firefuncs, "addPlayerToPrivGame");

      addUserToPrivGame(data)
        .then((res: any) => {
          console.log(res);
          setLoading(false);
          setValues({ msg: res.data.message, accesscode: "" });
        })
        .catch((err: any) => {
          console.log("error", err);
          setLoading(false);
          setValues({ msg: err.message, accesscode: "" });
        });
    }
  };

  return (
    <Container>
      <form
        onSubmit={(event) => {
          findPrivCashGame(event);
        }}
        style={{ width: "50%" }}
        className="form-styles"
      >
        <span>
          <input
            type="text"
            name="accesscode"
            value={values.accesscode}
            onChange={handleInputChange}
            className="form-control"
            placeholder="Access Code"
          />
        </span>
      </form>
      {loading ? (
        <CircularProgress color="secondary" />
      ) : (
        <>
          <button
            className="red-button"
            onClick={(event) => {
              findPrivCashGame(event);
            }}
          >
            Find Game
          </button>
          <div style={{ color: "red" }}>{values.msg}</div>
        </>
      )}
      <br />
    </Container>
  );
}

export default PrivateGameSearch;
